export class ApiError extends Error {
  constructor(message: string, readonly code?: string) {
    super(message);
  }
}

export function isStepUpRequired(error: unknown): boolean {
  return error instanceof ApiError && error.code === "step_up_required";
}

export interface PendingReview {
  registration_id: string;
  decision: "approve" | "reject";
}

const pendingReviewKey = "sectigo-edge.pending-review";

export function writePendingReview(storage: Storage, pending: PendingReview): void {
  try { storage.setItem(pendingReviewKey, JSON.stringify(pending)); } catch { /* storage unavailable: the admin reopens the review manually */ }
}

export function readPendingReview(storage: Storage): PendingReview | undefined {
  let raw: string | null = null;
  try {
    raw = storage.getItem(pendingReviewKey);
    storage.removeItem(pendingReviewKey);
  } catch {
    return undefined;
  }
  try {
    const value = JSON.parse(raw ?? "null") as Partial<PendingReview> | null;
    if (!value || typeof value.registration_id !== "string" || !/^reg_[0-9a-f-]{36}$/.test(value.registration_id)) return undefined;
    if (value.decision !== "approve" && value.decision !== "reject") return undefined;
    return { registration_id: value.registration_id, decision: value.decision };
  } catch {
    return undefined;
  }
}

// Privileged decisions need an Access token issued in the last ten minutes, and Access does not
// reissue its app token on navigation. Ending the app session makes the next load sign in again.
export async function reauthenticateWithAccess(fetcher: typeof fetch = fetch, reload: () => void = () => location.reload()): Promise<void> {
  await fetcher("/cdn-cgi/access/logout", { credentials: "include", redirect: "manual" }).catch(() => undefined);
  reload();
}
